<script>
  import { afterUpdate } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { QueryParams } from '@client/utils/query-params';

  import { generateUUID } from '@common/utils/strings';

  export let filter = {};
  export let label = '';
  export let onClick = () => {};
  export let param = null;
  export let autoClose = true;
  export let search = false;
  export let maxHeight = 'auto';
  export let placeholder = $format('label.SELECT');
  export let translateLabels = true;
  export let clearable = false;
  export let onClear = () => {};

  let isOpen = false;
  let filtered = filter;
  let initialized = false;

  let selected = null;

  const id = generateUUID();

  const onClickHandler = (e, item) => {
    Object.keys(filter).forEach((key) => {
      filter[key].enabled = false;
    });

    filter[item.value].enabled = true;

    selected = item;
    filter = { ...filter };
    onClick(e, item.value, filter, selected);
  };

  const onClearHandler = () => {
    Object.keys(filter).forEach((key) => {
      filter[key].enabled = false;
    });

    filter = { ...filter };
    onClear();
  };

  const onFocus = (e) => {
    e.stopPropagation();
    e.preventDefault();

    return false;
  };

  const onSearch = (e) => {
    const value = e.target.value;
    const keys = Object.keys(filter);

    filtered = keys.reduce((acc, key) => {
      if (key.toLowerCase().includes(value.toLowerCase())) {
        acc[key] = filter[key];
      }

      return acc;
    }, {});
  };

  const updateQueryParams = () => {
    if (selected?.value) {
      QueryParams.set(param, selected?.value);
    } else {
      QueryParams.delete(param);
    }
  };

  afterUpdate(() => {
    if (initialized) {
      if (param && Object.keys(filter).length) {
        updateQueryParams();
      }
    }

    initialized = true;
  });

  $: text = (config) =>
    translateLabels
      ? $format(config.label, { values: { amount: config.amount, time: $format(config.time) } })
      : config.label;

  $: filtered = filter;
  $: selected = Object.values(filter).find(({ enabled }) => enabled) ?? null;
</script>

<Dropdown {isOpen} {autoClose} toggle={() => (isOpen = !isOpen)}>
  <DropdownToggle tag="div">
    <div id="filter-{id}" class="select-filter" class:active={!!selected?.value}>
      {label}
      {#if selected?.label}
        {text(selected)}
      {:else}
        {placeholder}
      {/if}
      {#if clearable && selected?.value}
        <span on:click|stopPropagation={onClearHandler} role="button" tabindex="0">
          <Icon name="x" />
        </span>
      {/if}
    </div>
  </DropdownToggle>
  <DropdownMenu style="max-height: {maxHeight}; overflow: auto;">
    {#if search}
      <DropdownItem on:click={onFocus} toggle={false} class="select-filter-search-item-container">
        <div class="select-filter-search-item">
          <input type="text" on:click|preventDefault on:input={onSearch} placeholder={$format('label.SEARCH')} />
        </div>
      </DropdownItem>
    {/if}

    {#each Object.entries(filtered) as [value, config]}
      <DropdownItem on:click={(e) => onClickHandler(e, config)} active={selected?.value === config.value}>
        <div class="select-filter-item">
          <span class="select-filter-item-label">
            <slot name="label" {config}>
              {text(config)}
            </slot>
          </span>
        </div>
      </DropdownItem>
    {/each}
  </DropdownMenu>
</Dropdown>

<style lang="scss" src="./select.scss"></style>
